import type {
  RichTextEditorToolbarProps as ToolbarProps,
  RichTextEditorToolbarEntries as ToolbarEntries,
} from '@shopify/online-store-ui';
import {RichTextEditorToolbar as Toolbar} from '@shopify/online-store-ui';

import {
  Bold,
  Italic,
  FormattingList,
  Link,
  OrderedList,
  UnorderedList,
} from './components';

export function EditorToolbar({
  onAction,
  plugins,
  disabled,
}: Pick<ToolbarProps, 'onAction' | 'plugins' | 'disabled'>) {
  const toolbarEntries: ToolbarEntries = [
    [[FormattingList], [Bold, Italic], [Link], [UnorderedList, OrderedList]],
  ];

  return (
    <Toolbar
      plugins={plugins}
      onAction={onAction}
      entries={toolbarEntries}
      disabled={disabled}
    />
  );
}
